import React from 'react';
import { Link } from 'react-router-dom';
import { Home as HomeIcon, Compass, Plane, Train, Building2 } from 'lucide-react';
import SubpageShell from './SubpageShell';
import SEO from '../components/SEO';
import PageHeroImage from '../components/PageHeroImage';
import ServiceEnquiryForm from '../components/ServiceEnquiryForm';
import '../styles/ServiceEnquiry.css';

const THEMES = [
  { icon: Compass, label: 'Coastal Exploration', body: 'A sensory-paced journey through tides, coastlines and sea life.' },
  { icon: Plane, label: 'Aviation & Travel', body: 'How flight works — airport, cockpit and sky — explored safely at home.' },
  { icon: Train, label: 'Trains & Transportation', body: 'From the first signal to the big station: trains, tracks and travel.' },
  { icon: Building2, label: 'Future City', body: 'Imagine, design and build inclusive future cities together.' },
];

const ExperiencesHome = () => (
  <SubpageShell currentPath="/experiences/home">
    <SEO
      title="Experiences at Home | N3URO WORLD®"
      description="Private, themed, immersive family experiences delivered in your own environment."
      canonical="/experiences/home"
      image="https://n3uro.world/img/share-experiences-home.jpg"
    />
    <main className="subpage-hero">
      <PageHeroImage src="/img/experiences-home.webp" alt="N3URO Experiences at Home — a family watches an immersive ocean projection in their living room" testId="hero-image-experiences-home" />
      <nav aria-label="Breadcrumb" style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.65)', marginBottom: '0.5rem' }}>
        <Link to="/experiences" style={{ color: '#5BE9FF' }}>Experiences</Link> &middot; Experiences at Home
      </nav>
      <span className="subpage-eyebrow"><HomeIcon size={12} /> &nbsp;Experiences at Home</span>
      <h1 className="subpage-title">Bring discovery into your own environment.</h1>
      <p className="subpage-lede">
        Private, themed, immersive family experiences — designed around your family's pace, pace and
        preferences. Not an Academy workshop and no membership required.
      </p>

      <section className="service-grid" aria-label="Example themes">
        {THEMES.map(({ icon: Icon, label, body }) => (
          <article key={label} className="service-card" style={{ '--accent': '#5BE9FF' }}>
            <span className="service-card-icon" aria-hidden="true"><Icon size={22} strokeWidth={1.75} /></span>
            <h3>{label}</h3>
            <p>{body}</p>
          </article>
        ))}
      </section>

      <section id="enquire" aria-label="Home experience enquiry" style={{ marginTop: '1.5rem' }}>
        <h2 className="subpage-title" style={{ fontSize: 'var(--fs-h2)' }}>Enquire about a home experience</h2>
        <ServiceEnquiryForm
          serviceType="home"
          headline="Tell us a little about what you'd like"
          submitLabel="Send enquiry"
        />
      </section>
    </main>
  </SubpageShell>
);

export default ExperiencesHome;
